'use client'

import { useEffect, ReactNode } from 'react'
import s from './Modal.module.scss'
import { createPortal } from 'react-dom'

interface ModalProps {
  isOpen: boolean
  onClose: () => void
  children: ReactNode
  title?: string
  closable?: boolean
}

export function Modal({
  isOpen,
  onClose,
  children,
  title,
  closable = true,
}: ModalProps) {
  useEffect(() => {
    if (!closable) return

    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    if (isOpen) document.addEventListener('keydown', handleEsc)
    return () => document.removeEventListener('keydown', handleEsc)
  }, [isOpen, onClose, closable])

  if (!isOpen) return null

  return createPortal(
    <div className={s.overlay}>
      <div className={s.modal} onClick={(e) => e.stopPropagation()}>
        <div className={s.header}>
          {title && <h3 className={s.title}>{title}</h3>}
          {closable && (
            <button
              className={s.close}
              onClick={onClose}
              aria-label="Close modal"
            >
              ✕
            </button>
          )}
        </div>
        <div className={s.content}>{children}</div>
      </div>
    </div>,
    document.body
  )
}
